import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import useTheme from "@mui/material/styles/useTheme";

import Dialog from "components/dialog";

export interface AssignedTagsConfirmModalProps {
  open?: boolean;
  title?: string;
  onChange: () => void;
  onCancel: () => void;
}

export default function AssignedTagsConfirmModal({
  open,
  title,
  onChange,
  onCancel
}: AssignedTagsConfirmModalProps) {
  const theme = useTheme();

  return (
    <Dialog
      title={title || "Are you sure you want to continue?"}
      onClose={onCancel}
      open={Boolean(open)}
      dialogContentProps={{
        sx: {
          display: "flex",
          alignItems: "center",
          pb: "20px",
          flexDirection: "column"
        }
      }}
      sx={{
        zIndex: theme.zIndex.snackbar + 2
      }}
    >
      <DialogActions>
        <Button
          data-testid="confirm-dialog-cancel"
          variant="outlined"
          size="small"
          onClick={onCancel}
        >
          Cancel
        </Button>

        <Button
          data-testid="confirm-dialog-yes"
          variant="contained"
          size="small"
          onClick={() => {
            onChange();
          }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
